import { connect } from 'react-redux';
import { actions } from '../../../../../../redux/modules/admin/ports';
import PortList from './Port';


const ms2p = (state) => {
  return {
    ...state.ports,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(PortList);
